import { useMutation } from "react-query";
import { gql } from "graphql-request";
import { IProgramFamily } from "@pbm/programs-families/contracts";
import { usePbm2Url } from "@common/hooks/usePbm2Url";

export function useUpdateProgramFamily() {
  const { request } = usePbm2Url();
  return useMutation(async (variables: any) => {
    const { Rules_updateProgramFamily } = await request(
      gql`
        mutation ($input: Rules_UpdateProgramFamilyInput!) {
          Rules_updateProgramFamily(input: $input) {
            code
            name
            createdAt
            updatedAt
            deletedAt
          }
        }
      `,
      {
        input: {
          ...variables,
          code: undefined,
        },
      }
    );
    return Rules_updateProgramFamily as IProgramFamily;
  });
}
